import { gql } from '@apollo/client';

export default gql`
  query GetMatchingSets($kicId: String!) {
    matchingSets(kicId: $kicId) {
      kicId
      collectionId
      productId
      name
      imageId
      imageUrl
      prices {
        list {
          originalPrice
          discountPrice
          discountText
          description
          variant
        }
        member {
          originalPrice
          discountPrice
          discountText
          description
          variant
        }
      }
      brand
    }
  }
`;
